<template>
  <div class="container-fluid navigation-bar p-1 px-2">
    <button @click="toggle" class="burger">
      <font-awesome-icon icon="fa-solid fa-bars"/>
    </button>
    <div class="navbar-logo"></div>

    <div class="navigation-box">
      <button class="burger mx-2" @click="showTicketPopup" v-if="getSupportTicketCount > 0">
        <span class="notification-badge bg-warning">{{ getSupportTicketCount }} Tickets</span>
        <font-awesome-icon icon="bell"/>
      </button>
    </div>

    <custom-modal ref="posSignups" title="POS Sign-up Approvals" size="lg">
      <div v-if="pendingSignups.length === 0" class="text-center text-muted py-5">
        <font-awesome-icon icon="fa-solid fa-inbox" class="fa-3x mb-3"/>
        <p>No pending POS sign-ups</p>
      </div>
      <ul v-else class="list-unstyled">
        <li v-for="signup in pendingSignups" :key="signup.id" class="card mb-3">
          <div class="card-header d-flex justify-content-between align-items-center">
            <strong>{{ signup.storeName }}</strong>
            <small class="text-muted">{{ new Date(signup.submittedAt).toLocaleString() }}</small>
          </div>
          <div class="card-body">
            <p class="mb-1"><strong>TPIN:</strong> {{ signup.tpin }}</p>
            <p class="mb-1"><strong>Email:</strong> {{ signup.email }}</p>
            <p class="mb-1"><strong>Contact:</strong> {{ signup.contact_number }}</p>
            <p class="mb-1"><strong>Address:</strong> {{ signup.store_address }}</p>
            <p class="mb-0 text-muted" v-if="signup.storeReference"><strong>Ref:</strong> {{ signup.storeReference }}</p>
            <div class="mt-3 d-flex gap-2">
              <button class="btn btn-success btn-sm" @click="approveSignup(signup.id)">Approve</button>
              <button class="btn btn-danger btn-sm" @click="rejectSignup(signup.id)">Reject</button>
            </div>
          </div>
        </li>
      </ul>
    </custom-modal>

    <custom-modal ref="supportTickets" title="Pending Support Tickets" size="lg">
      <ul class="list-unstyled">
        <li v-for="ticket in getSupportTickets" :key="ticket.id+`-mobile`" class="card mb-2">
          <div class="card-header d-flex flex-row justify-content-between">
            Ticket #{{ ticket.id }}
            <div class="d-flex justify-content-end">
              <a class="btn btn-sm mx-3 btn-outline-info" @click="viewTicket(ticket.id)">View</a>
              <a class="btn btn-sm btn-primary" @click="handleClaimTicket(ticket.id)">Claim</a>
            </div>
          </div>
          <div class="card-body d-flex flex-column">
            <span>{{ ticket.title }}</span>
            <span>{{ ticket.client ? ticket.client : 'No Client Specified' }}</span>
            {{ ticket.store ? ticket.store : 'No Store Specified' }}
            <span>Created : {{ $dateTimeManager.shortenDisplay(ticket.createdDate) }}</span>
            <span>Due Date : {{ $dateTimeManager.shortenDisplay(ticket.dueDate) }}</span>
            <div class="d-flex flex-row justify-content-evenly">

            </div>
          </div>
        </li>
      </ul>
    </custom-modal>
    <audio ref="dingSound" src="@/assets/notification.mp3"></audio>
    <div class="user-settings my-2">

      <div class="fine-div" v-if="showFine" @click="goToFine">
        <p>Fined!</p>
        <img src="@/assets/img/debt.png" alt="tax man" class="flashing-image" />
      </div>

      <button class="burger mx-2" @click="showPosSignupPopup">
        <span class="notification-badge bg-info signup-badge" v-if="pendingSignupCount > 0">{{ pendingSignupCount }}</span>
        <font-awesome-icon icon="fa-solid fa-user-plus"/>
      </button>

      <button @click="findTicket" class="burger mx-3">
        <font-awesome-icon icon="magnifying-glass"/>
      </button>

      <button @click="syncData" class="burger">
        <font-awesome-icon icon="fa-solid fa-arrows-rotate"/>
      </button>
    </div>

    <custom-modal ref="ticketFinder" title="Ticket Finder" :is-form="true" :is-search-modal="true" @submit="checkTicket">
      <p class="text-primary text-sm">NB: Type a ticket number to quickly open it</p>

      <label for="checkTicketNumber" class="fw-bold">Ticket #</label>
      <input type="number" class="form-control" v-model="ticketNumber" id="checkTicketNumber" ref="tickNumber">
    </custom-modal>
  </div>
</template>
<script>
import CustomModal from "@/components/layout/CustomModal";
import Swal from "sweetalert2";
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import {errorHandler} from "@/Services/errorHandler";

export default {
  name: "NavigationBar",
  components: {CustomModal},
  data() {
    return {
      checkObject: false,
      showFine: false,
      previousTicketCount: 0,
      ticketNumber: ``,
      onlineStatusInterval: null,
      ticketCountInterval: null,
      pendingSignups: [],
    }
  },
  props: {
    toggle: {
      type: Function,
      require: true,
    },
  },
  computed: {
    pendingSignupCount() {
      return this.pendingSignups.length;
    },
    ...mapGetters(["getEmployeeFine"]),
    ...mapGetters(["getSupportTicketCount"]),
    ...mapGetters(["getSupportTickets"]),
    curUser() {
      return JSON.parse(localStorage.getItem('current_store'));
    },
  },
  mounted() {
    this.loadPendingSignups();
    setInterval(() => this.loadPendingSignups(), 5000);
  },
  methods: {
    loadPendingSignups() {
  try {
    const raw = localStorage.getItem('pending_pos_signups');
    this.pendingSignups = raw ? JSON.parse(raw) : [];
  } catch {
    this.pendingSignups = [];
  }
},
    showPosSignupPopup() {
      this.loadPendingSignups();
      this.$refs.posSignups.openModal();
    },
    async approveSignup(id) {
      const confirmed = await Swal.fire({
        icon: 'question',
        title: 'Approve this sign-up?',
        text: 'This will send the sign-up details to the email API.',
        showCancelButton: true,
        confirmButtonText: 'Yes, Approve',
        cancelButtonText: 'Cancel',
      });
      if (!confirmed.isConfirmed) return;

      const signup = this.pendingSignups.find(s => s.id === id);
      if (!signup) return;

      this.$utils.showLoading();
      if (signup) signup.status = 'APPROVED';
      const updated = this.pendingSignups.filter(s => s.id !== id);
      localStorage.setItem('pending_pos_signups', JSON.stringify(updated));
      this.pendingSignups = updated;
      this.$utils.hideLoading();
      Swal.fire({ icon: 'success', title: 'Approved', text: 'Sign-up has been approved.' });
    },
    async rejectSignup(id) {
      const confirmed = await Swal.fire({
        icon: 'warning',
        title: 'Reject this sign-up?',
        text: 'This action cannot be undone.',
        showCancelButton: true,
        confirmButtonText: 'Yes, Reject',
        cancelButtonText: 'Cancel',
      });
      if (!confirmed.isConfirmed) return;

      this.$utils.showLoading();
      const signup = this.pendingSignups.find(s => s.id === id);
      if (signup) signup.status = 'REJECTED';
      const updated = this.pendingSignups.filter(s => s.id !== id);
      localStorage.setItem('pending_pos_signups', JSON.stringify(updated));
      this.pendingSignups = updated;
      this.$utils.hideLoading();
      Swal.fire({ icon: 'success', title: 'Rejected', text: 'Sign-up has been rejected.' });
    },
    async fetchFineData() {
      try {
        const response = await axios.get(synergy4 + `disciplinaryAction/getEmployeeFine/${this.curUser.id}`);
        this.rows = response.data;
        console.log(this.rows);
      } catch (error) {
        await errorHandler.tomcatError(error);
      }
    },
    showFines() {
      if (Array.isArray(this.rows)) {
        this.showFine = this.rows.some(fine => fine.isPaid === false);
      } else {
        this.showFine = false;
      }
    },
    goToFine() {
      this.$router.push({ name: "fine"});
    },
    ...mapActions(["fetchEmployeeFine"]),
    syncData() {
      this.$utils.showLoading();
      window.location.reload(true);
      this.$utils.hideLoading();
    },
    async showTicketPopup() {
      if (this.getSupportTicketCount > 0) {
        await this.$store.dispatch(`getAllSupportTickets`);
        this.$refs.supportTickets.openModal();
      } else {
        Swal.fire({
          icon: 'info',
          title: 'No pending tickets available!',
          timer: 2000,
          showConfirmButton: false
        });
      }
    },

    ...mapActions(["connectWebSocket"]),
    // showTicketPopup() {
    //   if (this.getSupportTicketCount > 0) {
    //     this.$refs.supportTickets.openModal();
    //   } else {
    //     Swal.fire({
    //       icon: "info",
    //       title: "No pending tickets available!",
    //       timer: 2000,
    //       showConfirmButton: false,
    //     });
    //   }
    // },

    async handleClaimTicket(ticketId) {
      return this.claimTicket(ticketId).then(() => {
        return Swal.fire({
          icon: 'success',
          title: 'Claimed ticket successfully!',
          timer: 2000,
          showConfirmButton: false
        }).then(() => this.fetchAvailableTickets());
      });
    },
    viewTicket(ticketId) {
      if (this.$route.name === 'view-ticket') {
        return this.$router.replace({ name: 'view-ticket', params: { ticketId } })
            .then(()=>window.location.reload(true));
      }
      return this.$router.push({name: 'view-ticket', params: {ticketId}})
    },

    findTicket() {
      this.$refs.ticketFinder.openModal();
      setTimeout(() => {
        document.getElementById('checkTicketNumber').focus();
      }, 500);
    },
    checkTicket() {
      this.$utils.showLoading();
      return this.$store.dispatch(`checkTicket`, this.ticketNumber)
          .then(async (res) => {
            if (res) {
              this.viewTicket(this.ticketNumber)
              this.ticketNumber = ``
              return;
            }
            await responses.showWarning(`Ticket ${this.ticketNumber} not found`);
            return this.findTicket();
          }).finally(() => this.$utils.hideLoading());
    },
    updateUserOnlineStatus() {
      return this.$store.dispatch(`updateUserOnlineStatus`)
    },
    async fetchAvailableTickets() {
      this.$utils.showLoading();
      let currentCount = this.$store.getters.getSupportTicketCount;
      return this.$store.dispatch(`getAllSupportTickets`)
          .then(()=>{
            let newCount = this.$store.getters.getSupportTicketCount;
            if (currentCount < newCount) this.playDingSound();
          }).finally(()=>this.$utils.hideLoading());
    },
    async claimTicket(ticketNumber) {
      try {
        let user = JSON.parse(localStorage.getItem('current_store'));
        const userID = user.id;
        await axios.put(ticketApiV2 + 'ticket/claimTicket', {
          userID,
          ticketNumber
        }).then(() => {
          this.fetchAvailableTickets();
          this.$store.dispatch(`getPreLoginData`)
        });
      } catch (error) {
        return errorHandler.tomcatError(error)
      }
    },

    playDingSound() {
      this.$refs.dingSound.play();
    },
    startOnlineStatusUpdate() {
      this.onlineStatusInterval = setInterval(async () => {
        await this.updateUserOnlineStatus();
      }, 60000 * 10); // 60000ms = 1 minute * 30 = 30 minute
    },
    startSupportUpdate() {
      this.ticketCountInterval = setInterval(async () => {
        await this.$store.dispatch(`countSupportTickets`);
      }, 30000); // 60000ms = 1 minute * 30 = 30 minute
    },
  },
  watch:{
    getSupportTicketCount(newCount,currentCount){
      if (currentCount < newCount) this.playDingSound();
    },
  },
  beforeDestroy() {
    clearInterval(this.onlineStatusInterval);
    clearInterval(this.ticketCountInterval);
  },
  async created() {
    // await this.fetchFineData();
    this.showFines();
    await this.updateUserOnlineStatus();
    this.startOnlineStatusUpdate();
    this.startSupportUpdate();
  }
};
</script>
<style lang="scss" scoped>
.burger {
  width: 40px;
  height: 40px;
  background: transparent;
  color: white;
  font-size: 30px;
}

.user-settings {
  display: flex;
  flex-direction: row;
  justify-content: end;
}

button.btn {
  margin: 5px;
}

.red-blinking {
  color: red;
  animation: blinker 1.5s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.notification-badge {
  position: fixed;
  margin-right: 5px;
  color: white;
  border-radius: 5px;
  padding: 1px 6px 1px 6px;
  font-size: 12px;
  opacity: 0; /* Initially hidden */
  transform: scale(0); /* Initially small size */
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.burger .notification-badge {
  opacity: 1;
  transform: scale(1);
  animation: notification-pulse 1.5s infinite;
}

.notification-badge.signup-badge {
  margin-left: 10px;
  margin-right: -15px;
  margin-top: -5px;
}

@keyframes notification-pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 yellow;
  }
  50% {
    transform: scale(1.2);
    box-shadow: 0 0 0 10px rgba(255, 0, 0, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 yellow;
  }
}

//@import "src/assets/style/hide-table-mobile";
.text-sm {
  font-size: 12px;
}

@keyframes blinkingRed {
  0%, 100% { background-color: red; color: white; }
  50% { background-color: white; color: black; border: 2px solid black; }
}
.button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 40px;
  border: 2px solid red;
  cursor: pointer;
  border-radius: 0.4em;
  background: red;
  color: white;
  font-weight: bold;
  animation: blinkingRed 2s infinite;
}

.active_line {
  content: "";
  position: absolute;
  bottom: 0;
  width: 0.9em;
  height: 0.4em;
  background-color: #999;
  border: none;
  border-radius: 1em;
  transition: all 0.15s linear;
}

.button:active .active_line,
.button:focus .active_line {
  width: 2.3em;
  background-color: rgb(41, 126, 255);
}


@keyframes wow {
  20% {
    scale: 0.8;
  }

  30% {
    scale: 1;
    transform: translateY(0);
  }

  50% {
    transform: translateY(-6px);
  }

  65% {
    transform: translateY(4px);
  }

  80% {
    transform: translateY(0);
  }

  100% {
    scale: 1;
  }
}

.text {
  z-index: 1000;
  content: "";
  position: absolute;
  top: 4.5em;
  width: fit-content;
  height: 2.6em;
  background-color: #666;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 5px;
  text-shadow: 0 0 10px rgb(0, 0, 0);
  opacity: 0;
  transition: all 0.25s linear;
}

.button:hover .text {
  opacity: 1;
}

@keyframes flash {
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
}

.flashing-image {
  width: 30px;
  height: 30px;
  animation: flash 1s infinite; /* Flashes every 1 second */
}
.fine-div {
  width: 90px;
  padding: 5px;
  display: flex;

  border-radius: 10px;
  background-color: yellow;
  justify-content: space-between;
  align-items: center;
  position: relative;
  cursor: pointer;
}
.tooltip-text {
  visibility: hidden;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 10px;
  border-radius: 5px;
  position: absolute;
  bottom: 150%;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.3s;
}

.fine-div:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
</style>
